import { render } from "./UpdatePracticeModal.vue?vue&type=template&id=73e4105c&scoped=true"
import script from "./UpdatePracticeModal.vue?vue&type=script&lang=js"
export * from "./UpdatePracticeModal.vue?vue&type=script&lang=js"

import "./UpdatePracticeModal.vue?vue&type=style&index=0&id=73e4105c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e4105c"]])

export default __exports__